import React from 'react';

const Sun = (props) => {
  return (
    <div className={`sun ${props.sunState}`}>
      <svg
        width="294"
        height="295"
        viewBox="0 0 294 295"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M115.132 82.3286L142.679 74.0403L155.235 72.6636L208.95 106.777L216.995 132.645L200.292 180.817C195.204 186.726 183.927 199.008 179.522 200.874C174.014 203.206 143.709 210.974 138.187 208.246L103.21 190.969L84.4299 160.639C85.011 150.259 86.1699 128.487 86.1575 124.438C86.1452 120.39 88.9679 108.423 90.3808 102.945L115.132 82.3286Z"
          fill="#F3E8CD"
          stroke="#224F4F"
          strokeWidth="2.50851"
        />
        <path
          className="clear"
          d="M91.3259 152.902L93.2727 126.846L96.8791 111.303L122.352 85.0837L149.479 78.1163L171.201 93.3534L199.058 112.103C201.491 118.496 206.307 132.371 206.106 136.732C205.855 142.184 200.875 170.356 197.025 173.993L172.642 197.029L144.599 201.795C137.43 197.56 122.371 188.727 119.492 187.275C116.613 185.823 109.092 179.139 105.692 175.978L91.3259 152.902Z"
          fill="white"
          stroke="#224F4F"
          strokeWidth="2.50851"
        />
        <path
          className="clear"
          d="M126.548 100.941L146.094 95.0594L155.004 94.0825L193.12 118.289L198.828 136.645L186.976 170.827C183.366 175.019 175.364 183.734 172.237 185.058C168.33 186.713 146.826 192.225 142.907 190.29L118.088 178.03L104.762 156.508C105.174 149.143 105.997 133.694 105.988 130.821C105.979 127.948 107.982 119.457 108.985 115.57L126.548 100.941Z"
          stroke="#224F4F"
          strokeWidth="2.50851"
        />
        <path
          d="M48.9391 222.544L68.3952 182.917L87.4815 205.733L48.9391 222.544Z"
          fill="#F3E8CD"
        />
        <path
          d="M237.695 233.702L198.798 215.299L220.726 194.817L237.695 233.702Z"
          fill="#F3E8CD"
        />
        <path
          d="M267.2 165.937L225.219 176.135L230.385 146.291L267.2 165.937Z"
          fill="#F3E8CD"
        />
        <path
          d="M232.526 233.429L196.416 215.458L217.329 197.14L232.526 233.429Z"
          stroke="#224F4F"
          strokeWidth="2.78723"
        />
        <path
          d="M258.706 82.8612L234.073 115.926L220.887 91.5184L258.706 82.8612Z"
          stroke="#224F4F"
          strokeWidth="2.78723"
        />
        <path
          d="M109.56 17.9032L134.576 50.0511L108.157 57.5638L109.56 17.9032Z"
          stroke="#224F4F"
          strokeWidth="2.78723"
        />
        <path
          d="M20.9335 145.813L57.8493 128.713L57.9549 156.762L20.9335 145.813Z"
          stroke="#224F4F"
          strokeWidth="2.78723"
        />
        <path
          d="M270.277 161.038L230.943 170.624L236.059 143.007L270.277 161.038Z"
          stroke="#224F4F"
          strokeWidth="2.78723"
        />
        <path
          d="M197.319 31.6058L198.357 72.9619L173.02 62.7546L197.319 31.6058Z"
          stroke="#224F4F"
          strokeWidth="2.78723"
        />
        <path
          d="M45.5358 67.2381L84.8985 75.7277L68.8252 98.6123L45.5358 67.2381Z"
          stroke="#224F4F"
          strokeWidth="2.78723"
        />
        <path
          d="M50.5419 221.284L68.9416 184.235L86.272 205.713L50.5419 221.284Z"
          stroke="#224F4F"
          strokeWidth="2.78723"
        />
        <path
          d="M149.316 264.865L131.837 224.727L161.305 223.727L149.316 264.865Z"
          fill="#F3E8CD"
        />
        <path
          d="M141.92 272.554L125.385 235.014L152.714 234.33L141.92 272.554Z"
          stroke="#224F4F"
          strokeWidth="2.78723"
        />
      </svg>
    </div>
  );
};

export default Sun;
